import { supabase } from '../lib/supabase';

export const fetchAchievements = async () => {
  const { data, error } = await supabase?.from('achievements')?.select('*')?.order('created_at', { ascending: false });
  if (error) throw error;
  return data || [];
};

export const uploadAchievementArtwork = async (file, achievementId) => {
  const ext = file?.name?.split('.')?.pop() || 'png';
  const path = `achievements/${achievementId || Date.now()}_${Date.now()}.${ext}`;
  const { error: uploadError } = await supabase?.storage
    ?.from('badge-artwork')
    ?.upload(path, file, { upsert: true, contentType: file?.type });
  if (uploadError) throw uploadError;
  const { data } = supabase?.storage?.from('badge-artwork')?.getPublicUrl(path);
  return data?.publicUrl;
};

export const createAchievement = async (achievement) => {
  const { data, error } = await supabase?.from('achievements')?.insert([{
      name: achievement?.achievement_name,
      description: achievement?.description,
      target_type: achievement?.target_type,
      target_value: achievement?.target_value || 0,
      xp_reward: achievement?.xp_reward || 0,
      achievement_type: 'reading', // default required enum value
      requirement_value: achievement?.target_value || 0,
      artwork_url: achievement?.artwork_url || null,
    }])?.select()?.single();
  if (error) throw error;
  return data;
};

export const updateAchievement = async (id, achievement) => {
  const { data, error } = await supabase?.from('achievements')?.update({
      name: achievement?.achievement_name,
      description: achievement?.description,
      target_type: achievement?.target_type,
      target_value: achievement?.target_value || 0,
      xp_reward: achievement?.xp_reward || 0,
      requirement_value: achievement?.target_value || 0,
      artwork_url: achievement?.artwork_url !== undefined ? achievement?.artwork_url : undefined,
      updated_at: new Date()?.toISOString(),
    })?.eq('id', id)?.select()?.single();
  if (error) throw error;
  return data;
};

export const deleteAchievement = async (id) => {
  const { error } = await supabase?.from('achievements')?.delete()?.eq('id', id);
  if (error) throw error;
};
